import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { SapCdcFormGlobal } from '../../sapcdc-form-global/js/sapcdc-form-global';
import * as Cookies from 'js-cookie';
const classes = {
	contactImage: 'js-m-sapcdc-form__contact-image',
	stateHasImage: 'm-sapcdc-form__has-contact-image',
	stateAdditionalFieldsVisible: 'm-sapcdc-form__show-additional-fields',
	stateSuccess: 'state-m-sapcdc-form--success',
	input: 'gigya-input-text',
	floatLabel: 'state-a-label--is-floated',
	errorMsg: 'gigya-error-msg',
};

@createModule('SapCdcForm')
export class SapCdcForm extends TerrificSpec {
	$ctx: JQuery;
	$blockedMessage: JQuery;
	$input: JQuery;
	$floatLabel: JQuery;
	$errorMsg: JQuery;
	formId: string;
	ppFormId: string;
	screenSetId: string;
	contextLang: string;
	formHref: string;
	formFullId: string;
	envId: string;
	isExpired: boolean;
	redirectHref: string;
	submitSuccessfulMessage: string;
	isHiddenFormSubmit: boolean;
	isSendDataToGtmOnPageLoad: boolean;
	isShowSitecoreFormOnSubmit: boolean;
	sapCdcService: SapCdcFormGlobal;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		this.$blockedMessage = this.$ctx.find("p[data-id='blockedMsg']");
		this.envId = this.$ctx.data('environment-id');
		this.formId = this.$ctx.data('form-id');
		this.ppFormId = this.$ctx.data('pp-form-id');
		this.screenSetId = this.$ctx.data('screen-set-id');
		this.contextLang = this.$ctx.data('context-language');
		this.formFullId = `sapCdcForm_${this.$ctx.data('form-id')}`;
		this.formHref = this.$ctx.data('form-href');
		this.redirectHref = this.$ctx.data('redirect-href');
		this.isExpired = this.$ctx.data('expired');
		this.submitSuccessfulMessage = this.$ctx.data('submitsuccessful-message');
		this.isHiddenFormSubmit = this.$ctx.data('allow-hidden-form-submit');
		this.isSendDataToGtmOnPageLoad = this.$ctx.data('sc-send-data-to-gtm-pageload');
		this.sapCdcService = new SapCdcFormGlobal();

		if (!this.isExpired) {
			this.$blockedMessage.show();

			let gigyaSapCdc = (window as any)['gigya'];
			console.log('Gigya Settings ----' + gigyaSapCdc);

			let onAfterScreenLoadCalled = Cookies.get('onAfterScreenLoadCalled');
			if (onAfterScreenLoadCalled === undefined || onAfterScreenLoadCalled === 'true') {
				Cookies.set('onAfterScreenLoadCalled', 'false');
				this.loadSapCdcForm(this.formId, this.screenSetId, this.contextLang, this.$errorMsg);
			} else {
				setTimeout(() => {
					this.loadSapCdcForm(this.formId, this.screenSetId, this.contextLang, this.$errorMsg);
				}, 3000);
			}
		}

		resolve();
	}

	loadSapCdcForm(formId: string, screenSetId: string, contextLang: string, errorMsg: JQuery) {
		const onAfterScreenLoad = function(eventObj: any) {
			console.log('onAfterScreenLoad triggered for:', eventObj.sourceContainerID);
			Cookies.set('onAfterScreenLoadCalled', 'true');
			$this.sapCdcService = new SapCdcFormGlobal(); // Create a new instance for each call
			$this.sapCdcService.updateFormFields(eventObj, errorMsg);
			$this.$blockedMessage.hide();
			$this.sapCdcService.setFormStartDataToGtm(eventObj.sourceContainerID);
		};

		let $this = this;
		let gigyaSapCdc = (window as any)['gigya'];
		let startScreenId =
			Cookies.get('cdcUserData') === undefined && Cookies.get('cdcProfileData') === undefined
				? formId
				: this.ppFormId !== undefined && this.ppFormId !== ''
					? this.ppFormId
					: formId;
		console.log('Gigya Settings loadSapCdcForm----' + gigyaSapCdc);
		const divElement = document.getElementById('sapCdcForm_' + formId);
		if (divElement !== null) {
			divElement.id = 'sapCdcForm_' + startScreenId;
		}
		contextLang = contextLang === 'zh' ? 'zh-cn' : contextLang;
		if (typeof gigyaSapCdc != 'undefined') {
			var formContainerId = 'sapCdcForm_' + startScreenId;
			gigyaSapCdc.accounts.showScreenSet({
				screenSet: screenSetId,
				startScreen: startScreenId,
				containerID: formContainerId,
				lang: contextLang,
				onAfterScreenLoad: onAfterScreenLoad,
				onBeforeSubmit: function(event: any) {
					console.log('Before submit event:', event);
				},
				onAfterSubmit: function(event: any) {
					console.log('After submit event:', event);
					$this.sapCdcService = new SapCdcFormGlobal();

					if (event !== null && event.response !== null && event.response.UID !== null) {
						console.log('After submit event UID:', event.response.UID);
						$this.sapCdcService.onSapCdcAfterSubmit(event, $this, classes.stateSuccess);
						$this.sapCdcService.submitDataToGtm('sapCdcForm_' + event.screen);
					}
				},
				onSubmitSuccess: function(event: any) {
					console.log('Submit success:', event);
				},
				onError: function(error: any) {
					console.error('Submit error:', error);
				},
			});
		}
	}

	stop() {}
}
